<div class="stt-samples-wrap">
  <!-- Upload form: audio + title + case + locale + expected text. Всё
       обязательно — canUpload гейтит кнопку. -->
  <div class="upload-form">
    <div class="form-grid">
      <div class="field field-wide">
        <label i18n="@@benchmarks.stt.upload.audio">Аудио</label>
        <div class="audio-draft-row">
          @if (draftUrl(); as url) {
            <app-audio-player [audioUrl]="url" [compact]="true"></app-audio-player>
            @if (draftFileName()) {
              <span class="file-name">{{ draftFileName() }}</span>
            }
            <p-button
              icon="pi pi-times"
              severity="secondary"
              [text]="true"
              [rounded]="true"
              [disabled]="isUploading()"
              i18n-pTooltip="@@benchmarks.stt.upload.discard"
              pTooltip="Убрать запись"
              (click)="discardDraft()"
              i18n-ariaLabel="@@benchmarks.stt.upload.discard"
              ariaLabel="Убрать запись">
            </p-button>
          } @else {
            <span class="dim" i18n="@@benchmarks.stt.upload.audioEmpty">
              Запишите с микрофона или выберите файл
            </span>
          }
        </div>

        <div class="audio-actions">
          @if (!isRecording()) {
            <p-button
              i18n-label="@@benchmarks.stt.upload.record"
              label="Записать"
              icon="pi pi-microphone"
              severity="secondary"
              [outlined]="true"
              [disabled]="isUploading()"
              (click)="startRecording()">
            </p-button>
          } @else {
            <p-button
              i18n-label="@@benchmarks.stt.upload.stopRecord"
              label="Остановить"
              icon="pi pi-stop-circle"
              severity="danger"
              (click)="stopRecording()">
            </p-button>
          }

          <p-button
            i18n-label="@@benchmarks.stt.upload.pickFile"
            label="Загрузить"
            icon="pi pi-upload"
            severity="secondary"
            [outlined]="true"
            [disabled]="isRecording() || isUploading()"
            (click)="fileInput.click()">
          </p-button>
          <input #fileInput
                 type="file"
                 accept="audio/*"
                 hidden
                 (change)="onFileChange($event)" />
        </div>
      </div>

      <div class="field">
        <label i18n="@@benchmarks.stt.upload.title">Название</label>
        <input pInputText
               [ngModel]="draftTitle()"
               (ngModelChange)="draftTitle.set($event)"
               [disabled]="isUploading()"
               i18n-placeholder="@@benchmarks.stt.upload.titlePh"
               placeholder="Короткое имя сэмпла" />
      </div>

      <div class="field">
        <label i18n="@@benchmarks.stt.upload.case">Кейс (акустика)</label>
        <p-select
          [ngModel]="draftCase()"
          (ngModelChange)="draftCase.set($event)"
          [options]="caseOptions"
          optionLabel="label"
          optionValue="value"
          [disabled]="isUploading()"
          styleClass="w-full">
        </p-select>
      </div>

      <div class="field field-wide">
        <label i18n="@@benchmarks.stt.upload.expected">Эталонный текст</label>
        <textarea pTextarea
                  rows="3"
                  [ngModel]="draftExpected()"
                  (ngModelChange)="draftExpected.set($event)"
                  [disabled]="isUploading()"
                  i18n-placeholder="@@benchmarks.stt.upload.expectedPh"
                  placeholder="Что должно быть распознано (для расчёта WER/CER)">
        </textarea>
      </div>
    </div>

    <div class="upload-actions">
      <p-button
        icon="pi pi-times"
        severity="secondary"
        [text]="true"
        [disabled]="isUploading()"
        (click)="clearDraft()"
        i18n-label="@@benchmarks.stt.upload.clear"
        label="Очистить">
      </p-button>
      <p-button
        icon="pi pi-upload"
        severity="primary"
        [loading]="isUploading()"
        [disabled]="!canUpload()"
        (click)="upload()"
        i18n-label="@@benchmarks.stt.upload.submit"
        label="Загрузить">
      </p-button>
    </div>
  </div>

  <!-- Existing samples -->
  <div class="samples-list">
    <h4 i18n="@@benchmarks.stt.existing">Загруженные эталоны</h4>
    <p-table [value]="samples()" styleClass="samples-table">
      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@benchmarks.stt.col.title">Title</th>
          <th style="width: 18rem;" i18n="@@benchmarks.stt.col.audio">Audio</th>
          <th style="width: 10rem;" i18n="@@benchmarks.stt.col.case">Case</th>
          <th style="width: 8rem; text-align: right;" i18n="@@benchmarks.stt.col.duration">Duration</th>
          <th style="width: 4rem; text-align: center;"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-s>
        <tr>
          <td>
            <div class="sample-title">{{ s.title }}</div>
            @if (s.expected_text) {
              <div class="sample-expected" [class.expanded]="isExpanded(s.id)">
                {{ s.expected_text }}
              </div>
              @if ((s.expected_text.length ?? 0) > 120) {
                <button type="button" class="text-toggle"
                        (click)="toggleExpanded(s.id)">
                  @if (isExpanded(s.id)) {
                    <i class="pi pi-chevron-up"></i>
                    <span i18n="@@benchmarks.stt.expand.collapse">Свернуть</span>
                  } @else {
                    <i class="pi pi-chevron-down"></i>
                    <span i18n="@@benchmarks.stt.expand.show">Показать полностью</span>
                  }
                </button>
              }
            }
          </td>
          <td>
            @if (s.audio_url) {
              <app-audio-player [audioUrl]="s.audio_url" [compact]="true"></app-audio-player>
            } @else {
              <span class="dim" i18n="@@benchmarks.stt.audioMissing">—</span>
            }
          </td>
          <td>
            <p-tag [value]="caseLabel(s.case)" severity="info" [rounded]="true"></p-tag>
          </td>
          <td style="text-align: right;">{{ formatDurationMs(s.duration_ms) }}</td>
          <td style="text-align: center;">
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [text]="true"
              [rounded]="true"
              size="small"
              i18n-pTooltip="@@benchmarks.stt.remove.tooltip"
              pTooltip="Убрать из бенча (применится после Сохранить)"
              tooltipPosition="left"
              (click)="removed.emit(s.id)"
              i18n-ariaLabel="@@benchmarks.stt.remove.tooltip"
              ariaLabel="Убрать из бенча (применится после Сохранить)">
            </p-button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" style="text-align: center;" i18n="@@benchmarks.stt.empty">
            STT эталоны ещё не добавлены. Загрузите первый через форму выше.
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
